// components/DoctorNameInput.js
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { useDoctor } from '../contexts/DoctorContext';

const DoctorNameInput = ({ open, onClose }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const { updateDoctorName, doctorName } = useDoctor();

  // Initialiser le nom avec la valeur actuelle quand le dialog s'ouvre
  useEffect(() => {
    if (open && doctorName) {
      setName(doctorName);
    } else if (open) {
      setName('');
    }
  }, [open, doctorName]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Veuillez entrer votre nom');
      return;
    }

    if (name.trim().length < 2) {
      setError('Le nom doit contenir au moins 2 caractères');
      return;
    }

    updateDoctorName(name.trim());
    setName('');
    setError('');
    onClose();
  };

  const handleClose = () => {
    setName('');
    setError('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" component="div">
          {doctorName ? 'Modifier le Nom du Médecin' : 'Configuration du Médecin'}
        </Typography>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {doctorName 
                ? `Nom actuel : ${doctorName}. Modifiez votre nom pour identifier vos enregistrements dans le système.`
                : 'Veuillez entrer votre nom pour identifier vos enregistrements dans le système.'
              }
            </Typography>
          </Box>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          
          <TextField
            autoFocus
            margin="dense"
            label="Nom du médecin"
            placeholder="Ex: Dr. Diallo"
            fullWidth
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!error}
            helperText="Ce nom sera utilisé pour identifier vos enregistrements"
          />
        </DialogContent>
        
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Annuler
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            color="primary"
            disabled={!name.trim()}
          >
            {doctorName ? 'Modifier' : 'Confirmer'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DoctorNameInput;
